"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ChatBotPopOver: ()=>ChatBotPopOver
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const NotificationBox = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "ChatBotPopOver__NotificationBox"
})([
    "position:fixed;align-items:center;border-radius:6px 12px 20px 24px;cursor:pointer;"
]);
const fadeInFromBottomToTopAnimation = (props)=>{
    const animation = /*#__PURE__*/ (0, external_styled_components_namespaceObject.keyframes)([
        "from{transform:translate(",
        ",",
        ");-webkit-transform:translate(",
        ",",
        ");opacity:0;}to{transform:translate(",
        ",",
        ");opacity:1;}"
    ], props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
    return /*#__PURE__*/ (0, external_styled_components_namespaceObject.css)([
        "position:relative;animation:",
        ";animation-duration:0.4s;animation-fill-mode:forwards;animation-timing-function:cubic-bezier(0,0,0.3,1);"
    ], animation);
};
const AnimateBottomToTop = /*#__PURE__*/ external_styled_components_default().div.withConfig({
    displayName: "ChatBotPopOver__AnimateBottomToTop"
})([
    "",
    " position:absolute;bottom:0;right:15px;width:100%;height:100%;"
], fadeInFromBottomToTopAnimation);
const AnimateComponent = ({ children, animationProperties, animationType })=>{
    if ('BottomToTopLeft' === animationType || 'RightToLeft' === animationType) {
        const { bottom, from, to } = animationProperties;
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AnimateBottomToTop, {
            fromX: from.x,
            fromY: from.y,
            toX: to.x,
            toY: to.y,
            bottom: bottom,
            children: children
        });
    }
    return children;
};
function ChatBotPopOver(props) {
    const { onClose, onOpen, onDisplay, text, positionProps, containerProps, animationType = 'None', animationProperties, source, isFrequentNotification } = props;
    const { zIndex, bottom, right } = positionProps ?? {};
    const { width = '300px' } = containerProps ?? {};
    const [hidePopOver, setHidePopOver] = (0, external_react_namespaceObject.useState)(true);
    const today = new Date();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - today.getDay());
    startOfWeek.setHours(0, 0, 0, 0);
    (0, external_react_namespaceObject.useEffect)(()=>{
        const homePagePopoverLastSaved = localStorage.getItem('homePagePopoverLastSaved');
        const shouldNotShowHomePagePopOver = localStorage.getItem('shouldNotShowHomePagePopOver');
        const homePagePopoverLastSavedDate = homePagePopoverLastSaved ? new Date(homePagePopoverLastSaved) : null;
        if (isFrequentNotification && homePagePopoverLastSavedDate && shouldNotShowHomePagePopOver) if ('homepage' === source && 'false' === shouldNotShowHomePagePopOver) setHidePopOver(false);
        else if ('homepage' !== source) setHidePopOver(false);
        else if (homePagePopoverLastSavedDate && homePagePopoverLastSavedDate < startOfWeek) {
            localStorage.setItem('shouldNotShowHomePagePopOver', 'false');
            localStorage.setItem('homePagePopoverLastSaved', today.toString());
            setHidePopOver(false);
        } else setHidePopOver(true);
        else setHidePopOver(false);
    }, [
        isFrequentNotification
    ]);
    const handleHomePageClose = ()=>{
        if ('homepage' === source && isFrequentNotification) {
            localStorage.setItem('shouldNotShowHomePagePopOver', 'true');
            localStorage.setItem('homePagePopoverLastSaved', today.toString());
        }
    };
    (0, external_react_namespaceObject.useEffect)(()=>{
        if (false === hidePopOver && 'function' == typeof onDisplay) onDisplay();
    }, [
        hidePopOver,
        onDisplay
    ]);
    if (hidePopOver) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AnimateComponent, {
        animationType: animationType,
        animationProperties: animationProperties,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Absolute, {
            bottom: bottom,
            right: right,
            zIndex: zIndex,
            width: width,
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(NotificationBox, {
                pt: 3,
                pb: 3,
                px: 3,
                boxShadow: "lg",
                color: "text.base",
                onClick: function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    onOpen();
                },
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Absolute, {
                        bottom: "55px",
                        right: "-10px",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.CloseButton, {
                            "data-testid": "CHATBOT_POPOVER_CLOSEBUTTON",
                            title: "close",
                            variant: "filled",
                            size: "md",
                            onClick: function(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                handleHomePageClose();
                                onClose();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                        fontSize: 1,
                        children: text
                    })
                ]
            })
        })
    });
}
exports.ChatBotPopOver = __webpack_exports__.ChatBotPopOver;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChatBotPopOver"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
